// extracted by mini-css-extract-plugin
export default {"NavItems":"navigation-items_NavItems__GTm2s"};